/**
 * Custom Propagation
 * 
 * Allows you to control the next-page propagation based on user's response on a form
 */
define('components/custom-propagation',[
    'jquery',
    'logging'
], function($, logging) {
    'use strict';
    
    var _ModuleName = "Custom Propagation";
    var _config = {
        enabled: false
    }

    /**
     * Init function is run imediatly, so DOM is not necessarily available.
     * This can be used for getting things ready such as config storage and such
     * @param {object} config Configuration object with data parameters passed in
     */
    var init = function(config) {
        // If config is passed in, store it and enable this component
        if (config) {
            _config = config.customPropagationConfig;
            _config.enabled = true;

            logging.debug("Custom propogation component initialized", _ModuleName);
        }
    }

    /**
     * Get the target form field name
     */
    var getTargetFieldName = function() {
        if (_config.enabled) {
            return _config.targetFormFieldName;
        }
        return '';
    }

    /**
     * Get the configured destination if the value has an associated configuration
     * @param {any} value form element value that will be compared to configurations
     */
    var getDestination = function(value) {
        if (_config.enabled) {
            var destinationConfig = _config.destinations.find(function(d) { return d.value === value; });
            if (destinationConfig) {
                logging.debug("Custom propogation destination found: " + destinationConfig.destination, _ModuleName);
                return destinationConfig.destination;
            }
        }
        return '';
    }

    /**
     * Private functions should be preceded with an underscore and you can make
     * as many of these as need for use in the init and run functions
     */

    
    return {
        init: init,
        enabled: (function() { return _config.enabled; }),
        getTargetFieldName: getTargetFieldName,
        getDestination: getDestination
    }
});
